import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { Plus } from "lucide-react";
import { TaskAlertCard } from "./FollowUps";
import ConversionFunnel from "../components/ConversionFunnel";
import { Kpi } from "../components/dashboard/atoms";
import CrmSummaryCard from "../components/dashboard/CrmSummaryCard";
import RecentAssessmentsCard from "../components/dashboard/RecentAssessmentsCard";
import SuiteHealthStrip from "../components/dashboard/SuiteHealthStrip";
import SalesAttributionCard from "../components/dashboard/SalesAttributionCard";

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ total: 0, certification: 0, verification: 0 });
  const [crmStats, setCrmStats] = useState(null);
  const [clientStats, setClientStats] = useState(null);
  const [activity, setActivity] = useState([]);
  const [q, setQ] = useState("");
  const [auditType, setAuditType] = useState("all");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/assessments/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/crm/leads/stats", { params: { kind: "lead" } }).then((r) => setCrmStats(r.data)).catch(() => {});
    api.get("/crm/leads/stats", { params: { kind: "client" } }).then((r) => setClientStats(r.data)).catch(() => {});
    api.get("/crm/activity/recent").then((r) => setActivity(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = {};
    if (q) params.q = q;
    if (auditType && auditType !== "all") params.audit_type = auditType;
    api
      .get("/assessments", { params })
      .then((r) => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [q, auditType]);

  return (
    <div className="space-y-8">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-1">Consultant workspace</p>
          <h1 className="text-3xl font-semibold tracking-tight text-[#0D1B2A]">Dashboard</h1>
          <p className="text-sm text-slate-500 mt-1">Assessments, audit pathway breakdown and recent activity.</p>
        </div>
        <Link to="/new">
          <Button className="bg-[#1A7F6E] hover:bg-[#136053] text-white" data-testid="new-assessment-button">
            <Plus className="w-4 h-4 mr-2" />New assessment
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        <Kpi label="Total assessments" value={stats.total} testid="kpi-total" />
        <Kpi label="Certification clients" value={stats.certification} tint="text-[#0D1B2A]" testid="kpi-cert" />
        <Kpi label="Verification clients" value={stats.verification} tint="text-[#1A7F6E]" testid="kpi-verif" />
      </div>

      <TaskAlertCard />
      <SuiteHealthStrip />
      <CrmSummaryCard crmStats={crmStats} clientStats={clientStats} activity={activity} />
      <SalesAttributionCard isAdmin={user?.role === "admin"} />
      <ConversionFunnel />
      <RecentAssessmentsCard
        q={q} onQChange={setQ}
        auditType={auditType} onAuditTypeChange={setAuditType}
        loading={loading} items={items}
      />
    </div>
  );
}
